import {Injectable} from '@angular/core';
import {ParentTableService} from './parent-table.service';
import { ODataEntitySetService, ODataServiceFactory } from 'angular-odata';
import {Qualification} from '../../models/qualification';
import {exportable$} from './decorators/exportable';
import {map} from 'rxjs/operators';
import {ODataResponseMapper} from './mappers/odata-response-mapper';
import {SQDataConfiguration} from './configuration/OData-configuration';
import {QUALIFICATION_FLOW} from './configuration/constants';
import {HelperFunctions} from './configuration/helper-functions';

@Injectable({
  providedIn: 'root'
})
export class FmeaBacklogsService extends ParentTableService {
  private odata: ODataEntitySetService<Qualification>;
  private readonly config: SQDataConfiguration;
  @exportable$ risk_analysis_planning: any;

  constructor(public odataFactory: ODataServiceFactory) {
    super('FmeaBacklogsService');
    this.odata = this.odataFactory.entitySet<Qualification>('Overview(0)/Qualification');
    this.config = new SQDataConfiguration();
  }

  getData(pageIndex, count, sortModel, filterModel) {
    const orders = [];
    sortModel.forEach(x => orders.push(x.colId.replace(/\./g, '/') + ' ' + x.sort));

    let filter = `CurrentFlow eq ${QUALIFICATION_FLOW.Standard}`;
    filterModel['QualificationTool'] = {
      filter: 'Risk Analysis Planning',
      filterType: 'text',
      type: 'equals'
    };
    filter = HelperFunctions.addOdataFilters(filter, filterModel);

    const query = this.odata.entities().query(q => {
      q.top(count);
      q.skip(count * pageIndex);
      if (orders.length > 0) q.orderBy(orders);
      if (filter?.length) q.filter(filter);
      return q;
    });

    this.risk_analysis_planning = query;
    return this.risk_analysis_planning.fetch({ withCount: true }).pipe(map((r: any) => ODataResponseMapper.mapResponse(r)));
  }
}
